// 简历查询
export const RESUME_SEARCH = "RESUME_SEARCH";
export const RESUME_DETAIL = "RESUME_DETAIL";
export const RESUME_SEARCH_START = "RESUME_SEARCH_START";
export const RESUME_SEARCH_DONE = "RESUME_SEARCH_DONE";
export const CLEAR_RESUME_DETAIL_DATA = "CLEAR_RESUME_DETAIL_DATA";
export const CLEAR_RESUME_DATA = "CLEAR_RESUME_DATA";
export const VIEW_DETAILS_START = "VIEW_DETAILS_START";
export const VIEW_DETAILS_DONE = "VIEW_DETAILS_DONE";
export const DOWNLOAD_NUM = "DOWNLOAD_NUM";
export const ISCOLLECT = "ISCOLLECT";
export const NOCOLLECT = "NOCOLLECT";




// WEBPACK FOOTER //
// ./src/constants/resumeSearch.js